import React from "react";
import {featureIsActive, FLAGS} from "../../common/featureFlags";

const Price = (props) => (
    <span className={props.className}>
        <input className="idea-attribute__input"
               value={props.disabled ? "" : props.value}
               placeholder={props.placeholder}
               onChange={props.onChange}
               style={ Object.assign({width: "6em"}, props.style) }
               disabled={props.disabled}
               title={props.disabled ? props.disabledText : null}
        />

    </span>
);
Price.propTypes = {
    className: React.PropTypes.string,
    onChange: React.PropTypes.func.isRequired,
    placehoder: React.PropTypes.string,
    style: React.PropTypes.object,
    value: React.PropTypes.string.isRequired,
    disabled: React.PropTypes.bool,
    disabledText: React.PropTypes.string
};
Price.defaultProps = {
    className: "",
    style: {},
    disabled: false
};

export default Price;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/components/Price.js
 **/